document.querySelectorAll('form[data-contact-form]').forEach((form) => {
    const successEl = form.querySelector('.form-success');
    const errorBanner = form.querySelector('.form-error-banner');
    const submitBtn = form.querySelector('button[type="submit"]');

    const dateInputs = form.querySelectorAll('input[type="date"]');
    const refreshDateEmptyState = () => {
        dateInputs.forEach((input) => input.classList.toggle('is-empty', !input.value));
    };
    refreshDateEmptyState();
    dateInputs.forEach((input) => {
        input.addEventListener('input', refreshDateEmptyState);
        input.addEventListener('change', refreshDateEmptyState);
    });
    form.addEventListener('reset', () => requestAnimationFrame(refreshDateEmptyState));

    const clearErrors = () => {
        form.querySelectorAll('.is-error').forEach((g) => g.classList.remove('is-error'));
        form.querySelectorAll('.form-error').forEach((p) => {
            p.textContent = '';
            p.classList.add('sr-only');
        });
        if (errorBanner) {
            errorBanner.textContent = '';
            errorBanner.classList.remove('is-visible');
        }
    };

    const showFieldError = (name, message) => {
        const input = form.querySelector(`[name="${name}"]`);
        if (input) {
            const group = input.closest('.form-group, fieldset');
            if (group) group.classList.add('is-error');
        }
        const errEl = form.querySelector(`#form-${name}-error`);
        if (errEl) {
            errEl.textContent = message;
            errEl.classList.remove('sr-only');
        }
    };

    const showFormError = (message) => {
        if (errorBanner) {
            errorBanner.textContent = message;
            errorBanner.classList.add('is-visible');
            errorBanner.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    };

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        clearErrors();
        if (successEl) successEl.classList.remove('is-visible');
        if (submitBtn) submitBtn.disabled = true;

        try {
            const res = await fetch(form.action, {
                method: 'POST',
                body: new FormData(form),
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                credentials: 'same-origin',
            });

            let data = null;
            try {
                data = await res.json();
            } catch (_) {
                data = null;
            }

            if (res.ok && data && data.success) {
                form.reset();
                if (successEl) successEl.classList.add('is-visible');
            } else if (data && data.errors) {
                Object.entries(data.errors).forEach(([field, msg]) => showFieldError(field, msg));
                const firstErrInput = form.querySelector(
                    '.is-error input:not([type="hidden"]), .is-error select, .is-error textarea'
                );
                if (firstErrInput) firstErrInput.focus();
            } else {
                showFormError(
                    (data && data.message) ||
                        'Beim Versand ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.'
                );
            }
        } catch (err) {
            showFormError('Verbindungsfehler. Bitte versuchen Sie es erneut.');
        } finally {
            if (submitBtn) submitBtn.disabled = false;
        }
    });
});
